export default ({ editSchema, children }) => {
  return children(editSchema);
};
